import React from 'react';
import { Home, Building2, Package, Truck, Wrench, Map } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../mockData';
import { trackEvent } from '../lib/analytics';

const iconMap = {
  home: Home,
  building: Building2,
  package: Package,
  truck: Truck,
  wrench: Wrench,
  map: Map
};

export const Services = () => {
  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1E3A5F] mb-4">Our Services</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive moving solutions tailored to your needs. From small apartment moves to large interstate relocations.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                onClick={() => trackEvent('click_service_card', { service: service.title })}
                data-testid={`service-card-${service.id}`}
                className="border-2 border-gray-100 hover:border-[#FF8C42] hover:shadow-lg transition-all duration-300 group cursor-pointer"
              >
                <CardHeader>
                  <div className="w-14 h-14 rounded-lg bg-[#FF8C42]/10 flex items-center justify-center mb-4 group-hover:bg-[#FF8C42] transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-[#FF8C42] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-[#1E3A5F]">{service.title}</CardTitle>
                  <CardDescription className="text-gray-600">{service.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-700">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#FF8C42] mr-2"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};